import React from 'react';
import { useKeyboardNavigation, commonShortcuts } from '../../hooks/useKeyboardNavigation';

interface KeyboardNavigationProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component for global keyboard navigation
 * Sets up common keyboard shortcuts for the application
 */
const KeyboardNavigationProvider: React.FC<KeyboardNavigationProviderProps> = ({ children }) => {
  // Add keyboard help shortcut to common shortcuts
  const shortcuts = [
    ...commonShortcuts,
    {
      key: 'shift+?',
      handler: () => showKeyboardHelp(),
      description: 'Show keyboard shortcuts help',
      preventDefault: true,
    },
  ];

  const { showKeyboardHelp } = useKeyboardNavigation({
    shortcuts,
    enableArrowNavigation: false, // Can be enabled for specific components
  });

  return <>{children}</>;
};

export default KeyboardNavigationProvider;